

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUsers,
  deleteUser,
  setUsers,
  showUserById,
} from "../../features/admin/UserSlice";
import TableComponent from "../../components/TableComponent";
import ModalComponent from "../../components/admin/UserModal";
import StatusDropdown from "../../components/admin/StatusDropdownButton";
import ConfirmModal from "../../components/ConfirmModal";
import {
  PencilSquareIcon,
  TrashIcon,
  XCircleIcon,
  CheckCircleIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/outline";
import { fetchRoles } from "../../features/admin/RoleSlice";
import { toast } from "react-toastify";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
import UserApproveModal from "../../components/admin/UserApproveModal";
import ApiCustom from "../../utils/ApiCustom";
import { fetchMedias } from "../../features/admin/MediaSlice";
import AuditHistoryButton, {
  canViewAuditHistory,
} from "../../components/admin/AuditHistoryButton";

const Users = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const dispatch = useDispatch();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [userTypeFilter, setUserTypeFilter] = useState("admin");
  const [contentModal, setContentModal] = useState("");

  const users = useSelector((state) => state.users?.authUsers?.data?.users);
  const user = useSelector((state) => state.users.user);
  const status = useSelector((state) => state.users.status);
  const error = useSelector((state) => state.users.error);
  const [deleteId, setDeleteId] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const userId = localStorage.getItem("userId");
  const [approvingId, setApprovingId] = useState(null);
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isOpenApprove, setIsOpenApprove] = useState(false);
  const [isOpenCancleApprove, setIsOpenCancleApprove] = useState(false);

  const hasPermission = (requiredPermission) => {
    const userId = localStorage.getItem("userId");
    if (userId == 1) {
      return true;
    }
    const userPermissions = getUserPermissions();
    return userPermissions.includes(requiredPermission);
  };

  const getUserPermissions = () => {
    const permissions = localStorage.getItem("permissions");
    return permissions
      ? JSON.parse(permissions)?.map((p) => p.permissionSlug)
      : [];
  };

  const filteredUsers = users
    ? users
        .filter(
          (user) =>
            userTypeFilter === "all" ||
            (userTypeFilter === "admin" &&
              user.type?.toLowerCase().includes("admin")) ||
            (userTypeFilter === "user" &&
              !user.type?.toLowerCase().includes("admin"))
        )
        .filter((item) =>
          searchValue === ""
            ? true
            : [
                item.userFullName,
                item.userPhone,
                item.userEmail,
                item.role?.roleName,
              ].some((field) =>
                field?.toLowerCase().includes(searchValue.toLowerCase())
              )
        )
    : [];

  const handleOpenDeleteModal = (id) => {
    setDeleteId(id);
    setIsDeleteOpen(true);
  };

  const handleOpenApproveModal = (item = null) => {
    setCurrentUser(item);
    setIsOpenApprove(true);
    setContentModal("Bạn có muốn duyệt người dùng này không");
    setApprovingId(item.id);
  };

  const handleCloseApproveModal = () => {
    setIsOpenApprove(false);
    setApprovingId(null);
  };

  const handleOpenCancelApproveModal = (item = null) => {
    setCurrentUser(item);
    setIsOpenCancleApprove(true);
    setContentModal("Bạn có muốn bỏ duyệt người dùng này không");
    setApprovingId(item.id);
  };

  const handleCloseCancelApproveModal = () => {
    setIsOpenCancleApprove(false);
    setApprovingId(null);
  };

  const handleChangeUserStatus = (newStatus) => {
    console.log("handleChangeUserStatus", newStatus);
    const approveData = {
      id: currentUser.id,
      userCode: currentUser.userCode,
      userFullName: currentUser.userFullName,
      isApproved: newStatus,
    };
    ApiCustom.put("/user-change-lock-status", approveData)
      .then((res) => {
        if (res.status == 200) {
          toast.success(
            newStatus ? "Đã duyệt người dùng!" : "Đã bỏ duyệt người dùng!"
          );
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Đã xảy ra lỗi!");
      })
      .finally(() => {
        handleCloseApproveModal();
        handleCloseCancelApproveModal();
        dispatch(fetchUsers());
      });
  };

  const handleCloseDeleteModal = () => {
    setDeleteId(null);
    setIsDeleteOpen(false);
  };

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchRoles());
  }, []);

  useEffect(() => {
    if (status === "idle" && userId == 1) {
      window.scrollTo(0, 0);
      dispatch(fetchUsers());
      dispatch(fetchRoles());
    } else {
      window.scrollTo(0, 0);
      dispatch(showUserById(userId));
      dispatch(fetchRoles());
    }
  }, [status, dispatch]);

  const handleOpenModal = (user = null) => {
    setCurrentUser(user);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentUser(null);
  };
  const handleDeleteUser = async () => {
    let data = { ids: [deleteId] };
    try {
      await dispatch(deleteUser(data)).unwrap();
      await dispatch(fetchMedias());
      handleCloseDeleteModal();

      toast.success("Xóa người dùng thành công!");
    } catch (error) {
      toast.error("Đã xảy ra lỗi khi xóa người dùng!");
    }
  };
  const handleSaveUser = (user) => {
    if (user.id) {
      dispatch(setUsers(user));
    } else {
      const newUser = { ...user, id: Date.now() };
      dispatch(setUsers(newUser));
    }
    handleCloseModal();
  };
  const handleChangeStatus = (userId, newStatus) => {
    const approveData = {
      id: userId,
      userCode: users.find((u) => u.id === userId)?.userCode,
      userFullName: users.find((u) => u.id === userId)?.userFullName,
      isApproved: newStatus,
    };

    ApiCustom.put("/user-change-lock-status", approveData)
      .then((res) => {
        if (res.status == 200) {
          toast.success(
            newStatus ? "Đã duyệt người dùng!" : "Đã bỏ duyệt người dùng!"
          );
          dispatch(fetchUsers());
        }
      })
      .catch(() => {
        toast.error("Đã xảy ra lỗi!");
      });

    setIsStatusModalOpen(false);
    setSelectedUserId(null);
  };
  const tableSettings = {
    renderSettings: (item) => (
      <div className="flex space-x-2">
        {
          <button
            onClick={() => handleOpenModal(item)}
            className={`btn btn-outline btn-warning btn-sm px-3 my-1 rounded`}
          >
            <PencilSquareIcon className="w-5 h-5" />
          </button>
        }
        {/* {hasPermission("APPROVE_USER") && (
          <button
            onClick={() => handleOpenApproveModal(item)}
            title={!item.isApproved ? "Duyệt" : "Bỏ duyệt"}
            className={`btn btn-outline ${
              !item.isApproved ? "btn-accent" : "btn-error"
            } btn-sm px-3 my-1 rounded`}
          >
            {item.isApproved ? (
              <XCircleIcon className="w-5 h-5" />
            ) : (
              <CheckCircleIcon className="w-5 h-5" />
            )}
          </button>
        )} */}
        {hasPermission("USER_DESTROY") && (
          <button
            onClick={() => handleOpenDeleteModal(item.id)}
            className="btn btn-outline btn-error btn-sm px-3 my-1 rounded"
          >
            <TrashIcon className="w-5 h-5" />
          </button>
        )}
        <AuditHistoryButton module="USER" entityType="User" entityId={item.id} />
      </div>
    ),
  };
  const headers = [
    // { key: "userCode", label: "Mã người dùng" },
    // { key: "userFullName", label: "Họ và tên" },
    {
      key: "userAvatar",
      label: "Ảnh đại diện",
      render: (item) => (
        <div className="mx-2 w-12 h-12 rounded-full overflow-hidden">
          {item?.userAvatar ? (
            <img
              src={item.userAvatar}
              alt={item.userFullName}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          ) : (
            <img
              src={`https://ui-avatars.com/api/?name=${item?.userFullName}&size=200&background=random&color=fff&bold=true`}
              alt="Profile"
              className="w-full h-full object-cover"
              loading="eager"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `https://ui-avatars.com/api/?name=${item?.userFullName}&size=200&background=random&color=fff&bold=true`;
              }}
            />
          )}
        </div>
      ),
    },
    {
      key: "roleName",
      label: "Họ và tên",
      render: (item) => (
        <div className="min-w-32">
          <p className="font-medium">{item.userFullName}</p>
          <p className="text-sm text-gray-500">{item.userCode}</p>
        </div>
      ),
    },
    {
      key: "roleName",
      label: "Chức vụ",
      render: (item) => (
        <div className="text-sm">{item.role?.roleName || "----"}</div>
      ),
    },
    { key: "userEmail", label: "Email" },
    { key: "userPhone", label: "Số điện thoại" },
  ];

  if (hasPermission("APPROVE_USER")) {
    headers.push({
      key: "isApproved",
      label: "Trạng thái",
      render: (item) => (
        // <div className="relative">
        //   <button
        //     onClick={(e) => {
        //       e.stopPropagation();
        //       setSelectedUserId(selectedUserId === item.id ? null : item.id);
        //       setIsStatusModalOpen(!isStatusModalOpen);
        //     }}
        //     className={`flex items-center space-x-1 px-3 py-1 rounded-full text-sm ${
        //       item.isApproved
        //         ? "bg-green-100 text-green-800"
        //         : "bg-yellow-100 text-yellow-800"
        //     } whitespace-nowrap`}
        //   >
        //     <span>{item.isApproved ? "Đã duyệt" : "Đang chờ"}</span>
        //     <ChevronDownIcon className="w-4 h-4" />
        //   </button>

        //   {isStatusModalOpen && selectedUserId === item.id && (
        //     <div className="absolute left-0 top-full mt-1 bg-white rounded-lg shadow-lg z-50 w-32 py-1 border border-gray-200">
        //       <button
        //         onClick={() => handleChangeStatus(item.id, true)}
        //         className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 ${
        //           "text-green-500"
        //         }`}
        //       >
        //         Đã duyệt
        //       </button>
        //       <button
        //         onClick={() => handleChangeStatus(item.id, false)}
        //         className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 ${
        //           "text-yellow-500"
        //         }`}
        //       >
        //         Đang chờ
        //       </button>
        //     </div>
        //   )}
        // </div>
        <StatusDropdown
          options={[
            { value: true, label: "Đã duyệt" },
            { value: false, label: "Đang chờ" },
          ]}
          value={item.isApproved}
          onChange={(newStatus) =>
            newStatus
              ? handleOpenApproveModal(item)
              : handleOpenCancelApproveModal(item)
          }
          getStatusStyle={(value) =>
            value
              ? "bg-green-100 text-green-800"
              : "bg-yellow-100 text-yellow-800"
          }
        />
      ),
    });
  }

  if (
    hasPermission("USER_UPDATE") ||
    hasPermission("USER_SHOW") ||
    hasPermission("USER_SHOW_LIST") ||
    hasPermission("USER_DESTROY") ||
    canViewAuditHistory()
  ) {
    headers.push({ key: "setting", label: "Phương thức" });
  }

  if (status === "loading") {
    return <div>Đang tải dữ liệu...</div>;
  }
  if (status === "failed") {
    return <div>Lỗi: {error}</div>;
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Quản lý người dùng</h1>

      <div className=" block md:flex justify-between items-center mb-4">
        {hasPermission("USER_CREATE") ? (
          <button
            onClick={() => handleOpenModal()}
            className="btn btn-success transition-colors px-4 py-2 mb-4 rounded"
          >
            + Thêm Người Dùng
          </button>
        ) : (
          <div></div>
        )}

        <div className="flex gap-2">
          <div className=" flex items-center space-x-2">
            <label
              htmlFor="userSearchFilter"
              className="text-sm font-medium w-24"
            >
              Tìm kiếm:
            </label>
            <input
              type="search"
              className="w-full px-2 py-1 border rounded-lg focus:outline-none pr-10"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>
          <div className="flex items-center space-x-2">
            <label htmlFor="userTypeFilter" className="text-sm font-medium">
              Loại người dùng:
            </label>
            <select
              id="userTypeFilter"
              value={userTypeFilter}
              onChange={(e) => setUserTypeFilter(e.target.value)}
              className="select select-bordered select-sm"
            >
              <option value="admin">Ban điều hành</option>
              <option value="all">Hội viên</option>
            </select>
          </div>
        </div>
      </div>

      <TableComponent
        headers={headers}
        data={filteredUsers}
        settings={tableSettings}
      />
      {isModalOpen && (
        <ModalComponent
          userIdProp={currentUser?.id || null}
          onClose={handleCloseModal}
          onSave={handleSaveUser}
        />
      )}

      <ConfirmModal
        isOpen={isOpenApprove}
        onClose={handleCloseApproveModal}
        message={contentModal}
        onSubmit={() => handleChangeUserStatus(true)}
      />

      <ConfirmModal
        isOpen={isOpenCancleApprove}
        onClose={handleCloseCancelApproveModal}
        message={contentModal}
        onSubmit={() => handleChangeUserStatus(false)}
      />

      {/* <UserApproveModal
        approveAction={!currentUser?.isApproved}
        isOpen={isOpenApprove}
        onClose={handleCloseApprove}
        onConfirm={handleAppProve}
      /> */}
      <ConfirmDeleteModal
        isOpen={isDeleteOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleDeleteUser}
      />
    </div>
  );
};

export default Users;



